<div class="modal-wrapper">
  <div class="modal-header modal-header--custom">
    <div class="modal-header__title">
      <div class="modal-icon"><mat-icon>admin_panel_settings</mat-icon></div>
      <h4>{{ formMode }} Admin</h4>
    </div>
    <button mat-icon-button class="modal-close-btn" (click)="activeModal.close('close')" aria-label="Close">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="modal-body modal-form-body">
    <form [formGroup]="entryForm" novalidate>
      <mat-form-field class="w-100" appearance="outline">
        <mat-label>Admin Email</mat-label>
        <input matInput formControlName="admin_email"
               placeholder="Enter admin email"
               [readonly]="editAdmin" />
        @if (entryForm.controls['admin_email'].hasError('required')) {
          <mat-error>Email is required</mat-error>
        }
        @if (entryForm.controls['admin_email'].hasError('cannotContainSpace')) {
          <mat-error>Email cannot contain spaces</mat-error>
        }
      </mat-form-field>

      <mat-form-field class="w-100" appearance="outline">
        <mat-label>Description</mat-label>
        <input matInput formControlName="Description" placeholder="Enter description" />
        @if (entryForm.controls['Description'].hasError('required')) {
          <mat-error>Description is required</mat-error>
        }
      </mat-form-field>
    </form>
  </div>

  <div class="modal-footer modal-footer--custom">
    @if (!editAdmin) {
      <button mat-flat-button color="primary" class="modal-action-btn"
              [disabled]="entryForm.invalid"
              (click)="onCreate_Update()">
        <mat-icon>add</mat-icon> Add
      </button>
    }
    @if (editAdmin) {
      <button mat-stroked-button color="warn" class="modal-action-btn"
              [disabled]="entryForm.invalid"
              (click)="openConfirmModal('Are you sure you want to Delete?')">
        <mat-icon>delete</mat-icon> Delete
      </button>
    }
  </div>
</div>
